/**
 * Email form POST target for the portal (admissions, contact, feedback).
 * - Local dev: same-origin `/api/send-*` → setupProxy.js forwards to Express (backend/server.js).
 * - Production: `REACT_APP_CMS_BASE_URL/api/public/send-*` on the CMS so submissions are not
 *   blocked by Vercel Deployment Protection on a separate email API host.
 * - Fallback: legacy `REACT_APP_API_URL` (self-hosted Express or Vercel without protection).
 */
export function getFormApiUrl(endpoint) {
  const allowed = ['send-admission', 'send-contact', 'send-feedback', 'send-acceptance'];
  if (!allowed.includes(endpoint)) {
    throw new Error(`Invalid form endpoint: ${endpoint}`);
  }

  const isLocal =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocal) {
    return `/api/${endpoint}`;
  }

  const cmsBase = (process.env.REACT_APP_CMS_BASE_URL || '').replace(/\/$/, '');
  if (cmsBase) {
    return `${cmsBase}/api/public/${endpoint}`;
  }

  const legacy = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');
  return `${legacy}/api/${endpoint}`;
}
